import JobDetailsHeaderContent from "@/components/shared/jobs/job-details/job-details-header-content";
import routes from "@/lib/routes";
import { JobDetailsHeaderProps } from "@/lib/types/jobs.types";

export default function JobDetailsHeader({
  jobPosting,
  schoolData,
  stateConfig,
}: JobDetailsHeaderProps) {
  return (
    <div className="relative border-b border-border pb-6">
      <div className="flex flex-row items-start sm:justify-between gap-4">
        <JobDetailsHeaderContent
          jobPosting={jobPosting}
          titleHref={routes.getSchoolJob({
            state: stateConfig,
            districtId: schoolData.district.nces_id,
            schoolId: schoolData.nces_id,
            jobId: jobPosting.uuid,
          })}
        />
      </div>
    </div>
  );
}
